import { api } from './api';

export interface TenantDto {
  id: string;
  name: string;
  ownerUserId?: string;
  createdAt?: string;
  updatedAt?: string;
}

const normalizeTenant = (raw: any): TenantDto => ({
  id: String(raw.id ?? raw.Id),
  name: String(raw.name ?? raw.Name ?? ''),
  ownerUserId: raw.ownerUserId ?? raw.OwnerUserId,
  createdAt: raw.createdAt ?? raw.CreatedAt,
  updatedAt: raw.updatedAt ?? raw.UpdatedAt,
});

/** Superadmin: all tenants (cookie auth). */
export async function listTenantsAdmin(): Promise<TenantDto[]> {
  const { data } = await api.get<any[]>('/tenants');
  return Array.isArray(data) ? data.map(normalizeTenant) : [];
}
